import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/warren-bear.svg";
var WarrenBearSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  WarrenBearSolid_default as default
};
